import { size } from 'lodash/fp';
import styled from 'styled-components';

import { determineProductIdFromBundles } from '../../../../pages/choosable/pages/picker/utils/bundle';
import BundleChosenView from '../../../../pages/choosable/pages/picker/components/join-bar/components/bundle-chosen-view';
import NoBundleChosenView from '../../../../pages/choosable/pages/picker/components/join-bar/components/no-bundle-chosen-view';

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

type FooterProps = {
  customer: {
    frequency: string;
  };
  effectiveDate?: string;
  prices?: {};
  selectedBundles: string[];
};

const Footer = ({ customer, effectiveDate, prices, selectedBundles }: FooterProps) => {
  const isBundleChosen = size(selectedBundles) > 0;
  const productId = determineProductIdFromBundles(selectedBundles);

  return (
    <FooterWrapper>
      {isBundleChosen ? (
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ customer: { frequency: string; }; effectiveDate: string | undefined; isCondensed: true; prices: {} | undefined; productId: "choosable-60-teeth-eyes" | "choosable-60-teeth-muscle-bone" | ... 6 more ... | undefined; }' is not assignable to type 'Pick<BundleChosenViewProps, "customer" | "productId" | "isBundleChosen">'.
        <BundleChosenView
          {...{
            customer,
            effectiveDate,
            isCondensed: true,
            prices,
            productId,
          }}
        />
      ) : (
        <NoBundleChosenView isCondensed />
      )}
    </FooterWrapper>
  );
};

export default Footer;
